<template>
  <b-container>
    <h4>Seiten-Name:</h4>
    <b-input-group>
      <b-form-input v-model="site.name"></b-form-input>
      <b-input-group-append>
        <b-button variant="outline-success" @click="updateSiteName(site)">Speichern</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-input-group class="mt-2">
      <b-form-checkbox v-model="isPrivate" @change="updatePrivate()" size="lg" switch>Privat</b-form-checkbox>
    </b-input-group>
    <hr class="mt-4 mb-4">
    <h4>Sektionen:</h4>
    <b-list-group>
      <draggable v-model="sections" group="people" handle=".handle" @change="savePositions()">
        <b-list-group-item
            v-for="section in sections" :key="section.position"
        >
          <b-row>
            <b-col>
              <router-link :to="{ path: `/Sektion/${section.id}` }">{{ section.name }}</router-link>
            </b-col>
            <b-col cols="1">
              <b-icon-trash @click="confirmDeleteSection(section.id)"></b-icon-trash>
            </b-col>
            <b-col cols="1">
              <b-icon-list class="handle"></b-icon-list>
            </b-col>
          </b-row>
        </b-list-group-item>
      </draggable>
    </b-list-group>
    <hr class="mt-4 mb-4">
    <h4>Neue Sektion:</h4>
    <b-button variant="outline-success" v-b-modal.new-section block>Neue Sektion erstellen</b-button>

        <b-modal
            id="new-section"
            ref="modal"
            title="Neue Sektion"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk"
            cancel-title="Abbrechen"
            ok-title="Erstellen"
        >
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                    :state="nameState"
                    label="Name:"
                    label-for="name-input"
                    invalid-feedback="Bitte geben Sie einen Namen ein."
                >
                    <b-form-input
                        id="name-input"
                        v-model="name"
                        :state="nameState"
                        required
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    label="Typ:"
                    label-for="type-input"
                    invalid-feedback="Bitte wählen Sie einen Typ aus."
                >
                    <b-form-select v-model="type" :options="options" id="type-input"></b-form-select>
                </b-form-group>
            </form>
        </b-modal>
    </b-container>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import draggable from 'vuedraggable'

export default {
  name: "SectionList",
  components: {
    draggable
  },
  data() {
    return {
      siteId: parseInt(this.$route.params.siteId),
      name: '',
      nameState: null,
      selectState: null,
      type: null,
      options: [
        {id: 1, value: 'wysiwyg', text: 'Text'},
        {id: 2, value: 'files', text: 'Dateien'},
        {id: 3, value: 'slider', text: 'Bilder'},
      ]
    }
  },
  methods: {
    ...mapActions([
      'getSectionsForSite',
      'getSiteById',
      'updateSiteName',
      'createSection',
      'deleteSite',
      'saveSectionPositions',
      'deleteSection',
      'savePrivate',
    ]),
    ...mapMutations([
      'clearSections',
      'storeSections'
    ]),
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
      this.type = 'wysiwyg'
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names
      this.createSection({name: this.name, type: this.type, site: this.site})
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('new-section')
      })
    },
    confirmDeleteSection(sectionId) {
      this.$bvModal.msgBoxConfirm('Wollen Sie die Sektion wirklich löschen ?', {
        title: 'Löschen',
        okVariant: 'outline-danger',
        okTitle: 'Ja',
        cancelTitle: 'Abbrechen',
        cancelVariant: 'outline-success',
        centered: true
      })
          .then(value => {
            if (value) {
              this.deleteSection(sectionId)
            }
          })
    },
    savePositions() {
      const sections = this.sections.map((section, index) => section = {id: section.id, position: index})
      this.saveSectionPositions({sections, siteId: this.siteId})
    },
    updatePrivate() {
      this.savePrivate({siteId: this.site.id, isPrivate: this.isPrivate})
    }
  },
  mounted() {
    this.getSectionsForSite(this.siteId)
    this.getSiteById(this.siteId)
    this.type = 'wysiwyg'
  },
  computed: {
    ...mapGetters([
      'getStoredSections',
      'getStoredSite'
    ]),
    sections: {
      get() {
        return this.getStoredSections
      },
      set(sections) {
        this.storeSections(sections)
      }
    },
    site() {
      return this.getStoredSite
    },
    isPrivate: {
      set(value) {
        this.site.private = value
      },
      get() {
        return this.site.private === 1 || this.site.private
      }
    }
  },
  beforeDestroy() {
    this.clearSections()
  },
}
</script>

<style scoped>

</style>
